export const AlertActionsTypes = {
  ALERT_SUCCESS_SHOW: "ALERT_SUCCESS_SHOW",
  ALERT_SUCCESS_HIDE:"ALERT_SUCCESS_HIDE",
  };
  